// polyfill needed before imports are processed
polyfillAddtions()

import React from 'react'
import ReactDOM from 'react-dom'
import { Router, browserHistory } from 'react-router'
import { IconContext } from 'react-icons'

import routes from './Routes'
import { IStores } from './stores'
import ReviewStore from './stores/ReviewStore'
import ApplicationStore from './stores/ApplicationStore'
import 'core-js/stable'

import "@babel/polyfill"
import './fonts/font.scss'
import './static/fonts/stylesheet.css'

const initialState = {
  reviews: [],
  applications: [],
  languages: [],
  translations: []
}

// This allows the stores to know about each other
const store: IStores = {}
store.applicationStore = ApplicationStore.fromJS(initialState.applications, store),
store.reviewStore = ReviewStore.fromJS(initialState.reviews, store)

function injectStore() {
  return (Component, props) => {
    return (<Component {...props} {...store} />)
  }
}


ReactDOM.render(
  (
    <IconContext.Provider value={{ className: 'react-icons' }}>
      <Router
        createElement={injectStore()}
        history={browserHistory}
        routes={routes()}
      />
    </IconContext.Provider>
  ), document.getElementById('root')
)



/** Section of code to help with Polyfills. Can be moved to a separate file */

function polyfillAddtions() {
  if (typeof Object.assign != 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
      value: function assign(target, varArgs) { // .length of function is 2
        'use strict'
        if (target == null) { // TypeError if undefined or null
          throw new TypeError('Cannot convert undefined or null to object')
        }
  
        var to = Object(target)
  
        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index]
  
          if (nextSource != null) { // Skip over if undefined or null
            for (var nextKey in nextSource) {
              // Avoid bugs when hasOwnProperty is shadowed
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey]
              }
            }
          }
        }
        return to
      },
      writable: true,
      configurable: true
    })
  }
}